module.exports = __webpack_public_path__ + "img/image-02.d257a45d.webp";